module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Midi-ec870cbfb9455fdd0477a956a29c3edd.svg";